import React, {Fragment, PureComponent} from 'react';
import {Waypoint} from "react-waypoint";
import {connect} from 'react-redux';
import moment from 'moment';
import Registry from "../../../registry";
import {readNotification} from "../../../actions/notifications";
import UserListItemContextMenu from "../UserListItemContextMenu";

class NotificationItem extends PureComponent {
    formatDate = date => {
        if (typeof date === 'string') {
            date = new Date(date).getTime() / 1000;
        }
        return moment.unix(date).format('DD/MM/YYYY HH.mm')
    }
    
    onProfileClick = event => {
        event.stopPropagation();
        const {data: {data: { meta: { user }}}} = this.props;
    
        const roomEditorInstanceId = Registry.get('roomEditorInstance_id');
        const roomEditorInstance = Registry.get(roomEditorInstanceId);
        
        if (roomEditorInstance) {
            roomEditorInstance.insertMention(user.nick);
        }
    }
    
    toggleChatLogAnimation = enable => {
        this.setState({autoScrollDownDisabled: !enable})
    }
    
    showUserContextMenu = event => {
        event.preventDefault();
        event.persist();
        let {currentUser, currentRoom, openVideoWindow, data: {data: {meta: { user }}}} = this.props;
        
        UserListItemContextMenu.mount({
            user,
            currentUser,
            currentRoom,
            openVideoWindow,
            afterCloseFn: () => { this.toggleChatLogAnimation(true) },
            chatLog: true,
            ref: (r) => {
                this.contextMenu = r;
                this.contextMenu.setAnchor(event.target);
                this.contextMenu.position();
                this.contextMenu.open();
                this.toggleChatLogAnimation(false);
            }
        });
        
        // Reset selection on long-tap on nicknames on mobiles but keep selectability in general
        document.getSelection().empty();
    }
    
    onOpenNotification = () => {
        const {data: {data: { meta }}} = this.props;
        const lang = Registry.get('locale');
        let link = `${window.location.origin}${lang._code === 'en' ? '/en/' : '/'}membre/notification-list`;
        if (meta && meta.url) link = meta.url;
        const win = window.open(link, '_blank');
        win.focus();
    };
    
    onWaypointEnter = () => {
        const { data: { type, data: { id }}, readNotification} = this.props;

        const timeout = setTimeout(() => {
            if (type === 'followed_user_is_online') {
                readNotification({processedList: [id]});
            } else {
                const siteInterface = Registry.get('siteInterface');
                siteInterface.applyMemberNotificationAction({ ids: [id] })
                    .then((data) => {
                        readNotification(data.data.data);
                    })
                    .catch(err => console.error(err.message));
            }
            clearTimeout(timeout);
        }, 3000);
    }
    
    render() {
        const { data: {type, data: { date, is_read, meta }}, notifications: {showNotificationsWindow}} = this.props;
        if (!showNotificationsWindow) return null;
        const lang = Registry.get('locale');
        const isEnglish = lang._code === 'en';

        return (
            <Waypoint onPositionChange={this.onWaypointEnter}>
                <div className="item">
                    <div className="time">{this.formatDate(date)}</div>
                    {type !== "followed_user_is_online" ?
                        <div className={`message link ${!is_read ? 'new' : ''}`} onClick={this.onOpenNotification}>
                            {(type === "tip" || type === "tip_private_received") &&
                                <div>
                                    <div
                                        className="username"
                                        onClick={this.onProfileClick}
                                        onContextMenu={this.showUserContextMenu}
                                    >
                                        {meta.user.nick}
                                    </div>
                                    {lang.tip(meta.amount)}
                                </div>
                            }
                            {(type === "new_follower" || type === "guestbook_message") &&
                            <Fragment>
                                {isEnglish ?
                                    <div>
                                        {lang[type]}
                                        <div
                                            className="username margin-left"
                                            onClick={this.onProfileClick}
                                            onContextMenu={this.showUserContextMenu}
                                        >
                                            {meta.user.nick}
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div
                                            className="username"
                                            onClick={this.onProfileClick}
                                            onContextMenu={this.showUserContextMenu}
                                        >
                                            {meta.user.nick}
                                        </div>
                                        {lang[type]}
                                    </div>
                                }
                            </Fragment>
                            }
                            {(type === "gift" || type === "message") && (
                                <Fragment>
                                    <div
                                        className="username"
                                        onClick={this.onProfileClick}
                                        onContextMenu={this.showUserContextMenu}
                                    >
                                        {meta.user.nick}
                                    </div>
                                    {lang[type]}
                                </Fragment>
                            )}
                            {type === "membership_gift" &&
                                <Fragment>
                                    <div
                                        className="username"
                                        onClick={this.onProfileClick}
                                        onContextMenu={this.showUserContextMenu}
                                    >
                                        {meta.user.nick}
                                    </div>
                                    {lang[type].replace('%1', meta.duration )}
                                </Fragment>
                            }
                            {(type === "user_membership_expired" || type === "user_membership_almost_expired") &&
                                <Fragment>
                                    {lang[type].replace('%1', moment.unix(meta.expiration_date).format('DD/MM/YYYY'))}
                                </Fragment>
                            }
                            {type === "stream_record_error" &&
                                <Fragment>
                                    {lang.streamRecordError}
                                </Fragment>
                            }
                        </div>
                        :
                        <div className={`message ${!is_read ? 'new' : ''}`} >
                            <div
                                className="username"
                                onClick={this.onProfileClick}
                                onContextMenu={this.showUserContextMenu}
                            >
                                {meta.user.nick}
                            </div>
                            {lang[type]} {meta.room.name}
                        </div>
                    }
                </div>
            </Waypoint>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.currentUser,
    notifications: state.notifications,
})

const mapDispatchToProps = {
    readNotification
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationItem);



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/NotificationListItem/index.js